// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-lightbox.vel-modal[data-v-330a3f10]{background:rgba(10,19,34,.95)}.custom-lightbox[data-v-330a3f10] .vel-img{background:none;box-shadow:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
